<div class="bold_header" *ngIf="currentUserRole === PermissionRole.Company && us.currentUser && us.currentUser.permissions?.permissions.events.view">
    {{trans('systems.labels.eventDash')}}
</div>
<div class="white_round" *ngIf="currentUserRole === PermissionRole.Company && us.currentUser && us.currentUser.permissions?.permissions.events.view">
    <div id="cph_reactions_container">
        <app-dash-group-item *ngFor="let iGroup of lastSeenGroups" [groupItem]='iGroup'></app-dash-group-item>
    </div>
    <div id="cph_line"></div>
    <div id="cph_all_events" (click)="gotoAllEvents()">{{trans('systems.menu.allEvents')}}</div>
</div>
<div class="bold_header">
    <div id="cph_sh_text">{{trans('systems.titles.systems')}}</div>
    <div id="cph_sh_find" [inlineSVG]="'assets/images/find.svg'" (click)="openFind()"></div>
</div>
<ng-container *ngIf="currentUserRole === PermissionRole.SuperAdmin && us.currentUser && us.currentUser.permissions?.permissions.systems.view">
    <div class="white_round padding16" id="cph_total_systems">{{trans('systems.labels.totalSystems')}}: {{systems.getSystemCount()}}</div>
    <div class="separator16"></div>
</ng-container>
<div class="white_round" id="cph_systems" *ngIf="systems.systems.length > 0">
    <app-fragmenter #fragmentLoader [context]="that" [chunkFetcher]="fetchMoreSystems" [loaderBackground]="'#ffffff'">
        <app-cp-system-list-item *ngFor="let iSystem of systems.systems; let i = index" [systemItem]='iSystem' [showInstaller]='currentUserRole !== PermissionRole.Installer' [showBorder]="systems.systems.length-1 !== i" [showDelete]="true"></app-cp-system-list-item>
    </app-fragmenter>
</div>
<div id="cph_sys_history" *ngIf="currentUserRole === PermissionRole.Installer" (click)="openSystemHistory()">{{trans('systems.titles.history')}}</div>
<app-plus-button (plusClicked)="addSystem()" *ngIf="us.currentUser && (us.currentUser.permissions?.permissions.systems.create || us.currentUser.permissions?.permissions.system.create)"></app-plus-button>
